import React from 'react';
import { BrowserRouter} from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as api from "./api_function";

// Disable F12, Ctrl+Shift+I, Ctrl+U, Right-click
import disableDevtool from 'disable-devtool';

// if(window.location.hostname === "fieldforce.spectra.co" ){ // && sessionStorage.getItem('userName').toLowerCase() !== "manager1"
//   disableDevtool(); // <-- Block DevTools here
// }

// ======= DEV TOOL PROTECTION START =======
 
function isDevUser() {
  // Allow access if URL has devAccess=true (e.g. ?devAccess=true)
  console.log(window.location.search);
  if (window.location.search.includes('key=!@3$%')) {
    console.log(window.location.search);
    
    sessionStorage.setItem('key', '!@3$%');
    return true;
  }
 
  // Allow if localStorage has saved the dev flag
  return sessionStorage.getItem('key') === '!@3!@$%';
}
 
if (window.location.hostname === 'fieldforce.spectra.co' && !isDevUser()) {
  // Disable console logs
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
 
  // Block DevTools
  disableDevtool();
}

// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("/firebase-messaging-sw.js")
//     .then((registration) => {
//       console.log("Service Worker registered with scope:", registration.scope);
//     })
//     .catch((err) => {
//       console.error("Service Worker registration failed:", err);
//     });
// }

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(async (registrations) => {
    if (registrations.length === 0) {
      await api.saveLog({
        user_token_error: '❌ No service worker registered',
        user_name: sessionStorage.getItem('userName'),
        user_agent: navigator.userAgent,
      });
    }

    registrations.forEach(async (reg) => {
      await api.saveLog({
        user_token_error: `✅ SW found - scope: ${reg.scope}, state: ${reg.active?.state || 'not active'}`,
        user_name: sessionStorage.getItem('userName'),
        user_agent: navigator.userAgent,
      });

      if (reg.active?.state !== 'activated') {
        await api.saveLog({
          user_token_error: `⚠️ SW state is ${reg.active?.state}, not activated`,
          user_name: sessionStorage.getItem('userName'),
        });
      }
    });
  });
} else {
  await api.saveLog({
    user_token_error: '❌ Service Workers not supported in this browser',
    user_name: sessionStorage.getItem('userName'),
  });
}



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
 <BrowserRouter>
    <App />
    <ToastContainer/>
 </BrowserRouter>
  // </React.StrictMode>
  
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
